import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowLeft } from 'lucide-react';

interface BlogTemplateProps {
  title: string;
  date: string;
  author: string;
  children: React.ReactNode;
  tags?: string[];
  image?: string;
}

const BlogTemplate: React.FC<BlogTemplateProps> = ({
  title,
  date,
  author,
  children,
  tags = [],
  image
}) => {
  return (
    <article className="max-w-4xl mx-auto">
      <Link
        to="/community/blog"
        className="inline-flex items-center text-brand hover:text-brand-light mb-8"
      >
        <ArrowLeft className="w-4 h-4 mr-2" />
        Back to Blog
      </Link>

      {/* Header */}
      <header className="mb-8">
        {image && (
          <img
            src={image}
            alt={title}
            className="w-full h-[400px] object-cover rounded-lg mb-6"
          />
        )}
        <h1 className="text-4xl font-bold mb-4">{title}</h1>
        <div className="flex items-center text-content-secondary">
          <span>{author}</span>
          <span className="mx-2">•</span>
          <time>{new Date(date).toLocaleDateString()}</time>
        </div>
      </header>

      {/* Content */}
      <div className="prose prose-invert max-w-none">
        {children}
      </div>

      {/* Tags */}
      {tags.length > 0 && (
        <div className="mt-8 pt-8 border-t border-gray-800">
          <div className="flex flex-wrap gap-2">
            {tags.map(tag => (
              <span
                key={tag}
                className="px-3 py-1 bg-background rounded-full text-sm text-content-secondary"
              >
                {tag}
              </span>
            ))}
          </div>
        </div>
      )}
    </article>
  );
};

export default BlogTemplate;